
export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-blue-900 via-blue-800 to-indigo-900 py-12 border-t border-blue-800/50">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <h2 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: 'Rofoto, sans-serif' }}>
              MPG System
            </h2>
            <p className="text-blue-200 mb-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Transformamos tecnologia em resultado para o crescimento da sua empresa.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://instagram.com/mpg_systembrasil" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-blue-800/50 hover:bg-blue-500 rounded-lg flex items-center justify-center text-white transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line"></i>
              </a>
              <a 
                href="https://facebook.com/MPGSystemBrasil" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-blue-800/50 hover:bg-blue-500 rounded-lg flex items-center justify-center text-white transition-colors cursor-pointer"
              >
                <i className="ri-facebook-line"></i>
              </a>
              <a 
                href="https://wa.me/5511930682731" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-blue-800/50 hover:bg-blue-500 rounded-lg flex items-center justify-center text-white transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-line"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold mb-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Links Rápidos
            </h3>
            <ul className="space-y-2">
              <li>
                <a href="#inicio" className="text-blue-200 hover:text-blue-300 transition-colors">
                  Início
                </a>
              </li>
              <li>
                <a href="#solucoes" className="text-blue-200 hover:text-blue-300 transition-colors">
                  Soluções
                </a>
              </li>
              <li>
                <a href="#produto" className="text-blue-200 hover:text-blue-300 transition-colors">
                  MPGBOX
                </a>
              </li>
              <li>
                <a href="#contato" className="text-blue-200 hover:text-blue-300 transition-colors">
                  Contato
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold mb-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Contato
            </h3>
            <div className="space-y-2 text-blue-200 text-sm">
              <p>contato@mpgsystem.com.br</p>
              <p>(11) 93068-2731</p>
              <p>Santo André - SP</p>
              <p>CNPJ: 54.026.671/0001-50</p>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-blue-800/50 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-blue-200 text-sm mb-4 md:mb-0">
            © 2025 MPG System – Todos os direitos reservados
          </p>
        </div>
      </div>
    </footer>
  );
}
